import { List, Popup } from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import PROJET_ROW_TYPE from '../../constants/common/projetRowType';
import AutorisationModal from '../autorisation/AutorisationModal';
import ConfirmationOpenAutorisationModal from './Modal/ConfirmationOpenAutorisationModal';
import CreditPaiementCreationEngagementsModal from './Modal/CreditPaiementCreationEngagementsModal';
import CreditPaiementGestionEngagementsModal from './Modal/CreditPaiementGestionEngagementsModal';
import ReechelonementCreditModal from './ReechelonementCreditModal/ReechelonementCreditModal';
import STATUT_PROJET from '../../constants/common/statutProjet';

interface CreditPaiementTreeViewActionsProps {
	decision: number;
	disponible: number;
	engagement: number;
	exercice: string;
	hasChildren: boolean;
	identifiantComposant: number;
	identifiantProjet: number;
	montant: number;
	onRefresh: () => void;
	type: string;
	statutProjet: number;
}

const CreditPaiementTreeViewActions = ({
	decision,
	disponible,
	engagement,
	exercice,
	hasChildren,
	identifiantComposant,
	identifiantProjet,
	montant,
	onRefresh,
	type,
	statutProjet,
}: CreditPaiementTreeViewActionsProps) => {
	const [openAutorisationModal, setOpenAutorisationModal] =
		React.useState(false);
	const [openCreationEngagement, setOpenCreationEngagement] =
		React.useState(false);
	const [openGestionEngagement, setOpenGestionEngagement] =
		React.useState(false);
	const [openReechelonementEngagement, setOpenReechelonementEngagement] =
		React.useState(false);
	const [
		openConfirmationAutorisationModal,
		setOpenConfirmationAutorisationModal,
	] = React.useState(false);

	const isVisible = type !== PROJET_ROW_TYPE.PROJET || !hasChildren;
	const isProjetEnCours = statutProjet === STATUT_PROJET.EN_COURS;

	const handleAutorisationFinish = () => {
		setOpenAutorisationModal(false);
		onRefresh();
	};

	const handleOpenAutorisation = () => {
		setOpenConfirmationAutorisationModal(false);
		setOpenAutorisationModal(true);
	};

	const handleSuccessReechelonement = () => {
		setOpenReechelonementEngagement(false);
		setOpenConfirmationAutorisationModal(true);
		onRefresh();
	};

	return (
		<>
			<List horizontal>
				{isVisible && isProjetEnCours  && (
					<List.Item>
						<Popup
							content="Créer un engagement"
							position="bottom center"
							trigger={
								<Icon
									color="blue"
									cursor="pointer"
									iconSet="Lucide"
									name="NotebookPen"
									onClick={() => setOpenCreationEngagement(true)}
									size={16}
								/>
							}
						/>
					</List.Item>
				)}
				{isProjetEnCours  && (
					<List.Item>
						<Popup
							content="Gérer les engagements en-cours"
							position="bottom center"
							trigger={
								<Icon
									color="orange"
									cursor="pointer"
									iconSet="Lucide"
									name="NotebookText"
									onClick={() => setOpenGestionEngagement(true)}
									size={16}
								/>
							}
						/>
					</List.Item>
				)}
				{isVisible && isProjetEnCours  && (
					<List.Item>
						<Popup
							content="Rééchelonner les crédits"
							position="bottom center"
							trigger={
								<Icon
									color="purple"
									cursor="pointer"
									iconSet="Lucide"
									name="Calendar"
									onClick={() => setOpenReechelonementEngagement(true)}
									size={16}
								/>
							}
						/>
					</List.Item>
				)}
				{type === PROJET_ROW_TYPE.PROJET && (
					<List.Item>
						<Popup
							content="Gérer l’autorisation"
							position="bottom center"
							trigger={
								<Icon
									color="red"
									cursor="pointer"
									iconSet="Lucide"
									name="View"
									onClick={() => setOpenAutorisationModal(true)}
									size={16}
								/>
							}
						/>
					</List.Item>
				)}
			</List>
			{openCreationEngagement && (
				<CreditPaiementCreationEngagementsModal
					exercice={exercice}
					handleClose={() => setOpenCreationEngagement(false)}
					identifiantProjet={identifiantProjet}
					montantRow={montant}
					type={type}
				/>
			)}
			{openGestionEngagement && (
				<CreditPaiementGestionEngagementsModal
					engagement={engagement}
					exercice={exercice}
					handleClose={() => setOpenGestionEngagement(false)}
					identifiantProjet={identifiantProjet}
					type={type}
				/>
			)}
			{openReechelonementEngagement && (
				<ReechelonementCreditModal
					disponible={disponible}
					exercice={exercice}
					identifiantComposant={identifiantComposant}
					identifiantProjet={identifiantProjet}
					onClose={() => setOpenReechelonementEngagement(false)}
					onSuccess={handleSuccessReechelonement}
				/>
			)}
			{openAutorisationModal && (
				<AutorisationModal
					decision={decision}
					identifiantAutorisation={identifiantProjet}
					onClose={() => setOpenAutorisationModal(false)}
					onFinish={() => handleAutorisationFinish()}
				/>
			)}
			{openConfirmationAutorisationModal && (
				<ConfirmationOpenAutorisationModal
					onClose={() => setOpenConfirmationAutorisationModal(false)}
					onOpenAutorisation={handleOpenAutorisation}
				/>
			)}
		</>
	);
};

export default CreditPaiementTreeViewActions;
